import React from "react";
import { WSPage } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router";
import { OpenLineItemAgingReportDashboard } from "./OpenLineItemAgingReportDashboard";
import { WSQueries } from "../../../../query/WSQuery";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export const RouteOpenLineItemAgingReport: React.FC = () => {
  const history = useHistory();
  const queryCustomFieldsAll =
    queriesCustomFields.listCustomFields.useQueryAll();
  const customFields = (queryCustomFieldsAll.flatData ?? []).filter(
    customField =>
      customField.resourceType === CustomFieldResourceType.LINE_ITEM ||
      customField.resourceType === CustomFieldResourceType.PAYEE
  );

  return (
    <WSPage
      title="Open Line Item Aging"
      breadcrumb={{
        label: "Back",
        onClick() {
          history.push("/member/reports");
        },
        icon: "arrow-left"
      }}
    >
      <WSQueries queries={{ customFields: queryCustomFieldsAll }}>
        {() => (
          <OpenLineItemAgingReportDashboard customFieldsData={customFields} />
        )}
      </WSQueries>
    </WSPage>
  );
};
